module.exports = __webpack_public_path__ + "img/nav-02.0a7b79a8.jpg";